<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--full-page">
    <deprecation-banner />
    <router-view></router-view>
  </div>
</template>

<script>
import DeprecationBanner from '@/components/DeprecationBanner.vue'

export default {
  components: {
    DeprecationBanner
  }
}
</script>
